import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import OrderBookingComponent from '../components/order-booking.component';
import { bookings } from '../../../../../redux/bookings/action';
import { jobs } from '../../../../../redux/jobs/action';
import { selectJobsListItems } from '../../../../../redux/jobs/selector';
import { selectListItems } from '../../../../../redux/library/selector';
import { customers } from '../../../../../redux/customers/action';
import { selectCustomersListItems } from '../../../../../redux/customers/selector';
import { selectBookingsQueryItems } from '../../../../../redux/bookings/selector';
import { selectLogisticsOrdersListItems } from '../../../../../redux/logistics-orders/selector';
import { logisticsOrders } from '../../../../../redux/logistics-orders/action';

const ManagementBooking = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderBookingQuery = useSelector(selectBookingsQueryItems)
  const jobItemsData = useSelector(selectJobsListItems)
  const customerItemsData = useSelector(selectCustomersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const libraryData = useSelector(selectListItems)
  const orderItemsData =  useSelector(selectLogisticsOrdersListItems)
  const [
    selectedOrderBooking,
    setSelectedOrderBooking
  ] = useState<any>({})


  const fetchCategoryById = () => {
    dispatch(bookings.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/transport/logistics/order-bookings/fetch-detail`, entity: 'bookings', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedOrderBooking({ ...selectedOrderBooking, [field]: event });
  }


  useEffect(
    () => {
      dispatch(jobs.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {
        }
      }))
        .then(() => {
          dispatch(customers.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`,
            entity: 'customers',
            jsonData: {}
          }));
        })
        .then(() => {
          dispatch(logisticsOrders.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/logistics-orders/fetch`, entity: 'order', jsonData:  {
      
        "Context": {},
        "Records": [{}],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 100,
          "SortField": "LogisticsOrderId",
          "SortOrder": "desc",
        }
      }
          }))
        }).then(() => {
          if (parmas?.id > 0) {
            fetchCategoryById()
            setIsLoading(false)
          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedOrderBooking(orderBookingQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const itemData = {
      "Id": selectedOrderBooking?.Id || 0,
      "OwnerType": selectedOrderBooking?.OwnerType || "LogisticsOrder",
      "OwnerId": selectedOrderBooking?.OwnerId || 0,
      "LogisticsOrderId": selectedOrderBooking?.LogisticsOrderId,
      "InvoiceNumber": selectedOrderBooking?.InvoiceNumber,
      "CustomerId": selectedOrderBooking?.CustomerId,
      "JobId": selectedOrderBooking?.JobId,
      "ShippingStatusId": selectedOrderBooking?.ShippingStatusId,
      "Description": selectedOrderBooking?.Description


    }
    if (parmas?.id > 0) {
      await dispatch(bookings.resetAction({ actionType: 'update' }))
      await dispatch(bookings.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/Logistics/order-bookings`, entity: 'bookings', jsonData: {

          Records: [
            itemData
          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(bookings.resetAction({ actionType: 'create' }))
      await dispatch(bookings.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/Logistics/order-bookings`, entity: 'bookings', jsonData: {

          Records: [
            itemData
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/logistics/order-bookings')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <OrderBookingComponent
          jobs={jobItemsData?.result?.items}
          shippingStatus={libraryData?.result?.LogisticsBookingStatus}
          customers={customerItemsData?.result?.items}
          salesOrders={orderItemsData?.result?.items}
          selectedOrderBooking={selectedOrderBooking}
          onInnerBasicFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementBooking;